import Vue from 'vue';

const state = {
  notificaciones: [],
  paginacion: {
    page: 1,
    perPage: 10,
    total: 0,
    lastPage: 1
  },
  loading: false,
  error: null
};

const actions = {
  fetchNotificaciones: ({commit, state}, payload = {}) => {
    const page = payload.page || state.paginacion.page;
    const perPage = payload.perPage || state.paginacion.perPage;
    
    commit('setLoading', true);
    commit('setError', null);
    
    return new Promise((resolve, reject) => {
      Vue.http.get('notificaciones', {
        params: {
          page: page,
          per_page: perPage
        }
      }).then(
        response => {
          // Asumiendo que la respuesta viene con estructura de paginación Laravel
          const data = response.data;
          
          if (payload.append) {
            // Para "cargar más" - agregar a las existentes
            commit('appendNotificaciones', data.data || data);
          } else {
            // Para recargar - reemplazar todas
            commit('setNotificaciones', data.data || data);
          }
          
          // Actualizar información de paginación si existe
          if (data.current_page) {
            commit('setPaginacion', {
              page: data.current_page,
              perPage: data.per_page,
              total: data.total,
              lastPage: data.last_page
            });
          }
          
          commit('setLoading', false);
          resolve(data);
        }
      ).catch(error => {
        commit('setError', error.message || 'Error al cargar notificaciones');
        commit('setLoading', false);
        reject(error);
      });
    });
  },

  loadMoreNotificaciones: ({dispatch, state}) => {
    if (state.paginacion.page < state.paginacion.lastPage) {
      return dispatch('fetchNotificaciones', {
        page: state.paginacion.page + 1,
        append: true
      });
    }
    return Promise.resolve();
  },

  refreshNotificaciones: ({dispatch}) => {
    return dispatch('fetchNotificaciones', { page: 1 });
  },

  marcarComoLeida: ({commit}, notificacionId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`notificaciones/${notificacionId}/marcar-leida`).then(
        response => {
          // Marcar como leída en el estado local
          commit('markAsRead', notificacionId);
          resolve(response.data);
        }
      ).catch(error => {
        console.error('Error al marcar notificación como leída:', error);
        reject(error);
      });
    });
  },

  marcarTodasComoLeidas: ({commit}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post('notificaciones/marcar-todas-leidas').then(
        response => {
          // Marcar todas como leídas en el estado local
          commit('markAllAsRead');
          resolve(response.data);
        }
      ).catch(error => {
        console.error('Error al marcar todas las notificaciones como leídas:', error);
        reject(error);
      });
    });
  },

  clearNotificaciones: ({commit}) => {
    commit('setNotificaciones', []);
    commit('resetPaginacion');
  }
};

const getters = {
  hasMoreNotificaciones: (state) => {
    return state.paginacion.page < state.paginacion.lastPage;
  },

  unreadCount: (state) => {
    return state.notificaciones.filter(n => !n.leida && !n.read).length;
  },

  notificacionesRecientes: (state) => {
    // Retorna las últimas 5 notificaciones
    return state.notificaciones.slice(0, 5);
  }
};

const mutations = {
  setNotificaciones: (state, notificaciones) => {
    state.notificaciones = notificaciones;
  },

  appendNotificaciones: (state, notificaciones) => {
    state.notificaciones = [...state.notificaciones, ...notificaciones];
  },

  setPaginacion: (state, paginacion) => {
    state.paginacion = {
      ...state.paginacion,
      ...paginacion
    };
  },

  resetPaginacion: (state) => {
    state.paginacion = {
      page: 1,
      perPage: 10,
      total: 0,
      lastPage: 1
    };
  },

  setLoading: (state, loading) => {
    state.loading = loading;
  },

  setError: (state, error) => {
    state.error = error;
  },

  markAsRead: (state, notificacionId) => {
    const notificacion = state.notificaciones.find(n => n.id === notificacionId);
    if (notificacion) {
      notificacion.leida = true;
      notificacion.read = true;
    }
  },

  markAllAsRead: (state) => {
    state.notificaciones.forEach(n => {
      n.leida = true;
      n.read = true;
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
